(function () {
  'use strict';

  function createStepLabel(stepNumber, stepText) {
    var wrap = document.createElement('div');
    wrap.className = 'nerolia-pdp__step-label nerolia-pdp__step-label--injected';
    wrap.innerHTML =
      '<span class="nerolia-pdp__step-num">' +
      stepNumber +
      '</span><span class="nerolia-pdp__step-text">' +
      stepText +
      '</span>';
    return wrap;
  }

  function createReferralAccordion(stepLabel) {
    var details = document.createElement('details');
    details.className = 'nerolia-referral';
    details.setAttribute('data-nerolia-referral', '');

    var stepHtml = stepLabel
      ? '<span class="nerolia-referral__step">' + stepLabel + '</span>'
      : '';

    details.innerHTML =
      '<summary class="nerolia-referral__summary">' +
      stepHtml +
      '<span class="nerolia-referral__title">Have a referral code?</span>' +
      '<span class="nerolia-referral__chevron" aria-hidden="true">' +
      '<svg width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span></summary>' +
      '<div class="nerolia-referral__body"><div class="nerolia-referral__field">' +
      '<input type="text" class="nerolia-referral__input" placeholder="Enter referral code" data-nerolia-referral-input aria-label="Referral code">' +
      '<button type="button" class="nerolia-referral__apply" data-nerolia-referral-apply>Apply</button>' +
      '</div></div>';

    return details;
  }

  function injectRitualExtras(root) {
    var detailsColumn = root.querySelector('.product-details .group-block');
    if (!detailsColumn || detailsColumn.querySelector('[data-nerolia-referral-injected]')) return;

    var recharge =
      detailsColumn.querySelector('[id*="shopify-block-recharge"]') ||
      detailsColumn.querySelector('.shopify-app-block');

    var referral = createReferralAccordion('');
    referral.setAttribute('data-nerolia-referral-injected', '');

    if (recharge && recharge.nextSibling) {
      detailsColumn.insertBefore(referral, recharge.nextSibling);
    } else {
      detailsColumn.appendChild(referral);
    }

    var breadcrumb = detailsColumn.querySelector('.text-block p');
    if (breadcrumb && breadcrumb.textContent.indexOf('Home') > -1) {
      breadcrumb.parentElement.classList.add('nerolia-breadcrumbs-wrap');
    }
  }

  function injectRefillExtras(root) {
    var detailsColumn = root.querySelector('.product-details .group-block');
    if (!detailsColumn || detailsColumn.querySelector('[data-nerolia-step-injected]')) return;

    var variantPicker =
      detailsColumn.querySelector('variant-picker') ||
      detailsColumn.querySelector('.variant-picker');

    var recharge =
      detailsColumn.querySelector('[id*="shopify-block-recharge"]') ||
      detailsColumn.querySelector('.shopify-app-block');

    if (variantPicker) {
      var step1 = createStepLabel('STEP 1', 'Choose your refill collection');
      step1.setAttribute('data-nerolia-step-injected', 'step1');
      variantPicker.parentNode.insertBefore(step1, variantPicker);
    }

    if (recharge) {
      var step2 = createStepLabel('STEP 2', 'Choose your purchase type');
      step2.setAttribute('data-nerolia-step-injected', 'step2');
      recharge.parentNode.insertBefore(step2, recharge);
    }

    var saveNote = detailsColumn.querySelector('.text-block p');
    var saveParagraphs = detailsColumn.querySelectorAll('.text-block p');
    saveParagraphs.forEach(function (p) {
      if (p.textContent.indexOf('save 15%') > -1) {
        p.parentElement.classList.add('nerolia-pdp__save-note-wrap');
      }
      if (p.textContent.indexOf('Pause, skip') > -1) {
        p.parentElement.classList.add('nerolia-pdp__subscription-note-wrap');
      }
    });

    if (!detailsColumn.querySelector('[data-nerolia-referral-injected]')) {
      var referral = createReferralAccordion('STEP 3');
      referral.setAttribute('data-nerolia-referral-injected', '');

      if (saveNote) {
        var saveWrap = detailsColumn.querySelector('.nerolia-pdp__save-note-wrap');
        if (saveWrap) {
          detailsColumn.insertBefore(referral, saveWrap);
        } else {
          detailsColumn.appendChild(referral);
        }
      } else {
        detailsColumn.appendChild(referral);
      }
    }

    var eyebrow = detailsColumn.querySelector('.group-block .text-block p');
    if (eyebrow && eyebrow.textContent.trim() === 'Refill Collection') {
      eyebrow.classList.add('nerolia-pdp__eyebrow');
    }
  }

  function initQuantity(root) {
    var wrap = root.querySelector('[data-nerolia-quantity]');
    if (!wrap) return;

    var input = wrap.querySelector('[data-qty-input]');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');

    if (!input || !minus || !plus) return;

    minus.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      if (val > 1) input.value = val - 1;
    });

    plus.addEventListener('click', function () {
      var val = parseInt(input.value, 10) || 1;
      input.value = val + 1;
    });
  }

  function initReferral(root) {
    var applyBtns = root.querySelectorAll('[data-nerolia-referral-apply]');
    applyBtns.forEach(function (applyBtn) {
      if (applyBtn.dataset.bound) return;
      applyBtn.dataset.bound = 'true';

      var input = applyBtn.closest('.nerolia-referral__field')?.querySelector('[data-nerolia-referral-input]');
      if (!input) return;

      applyBtn.addEventListener('click', function () {
        var code = input.value.trim();
        if (!code) return;
        applyBtn.textContent = 'Applied';
        applyBtn.disabled = true;
        input.disabled = true;
      });
    });
  }

  function styleRechargeWidget(root) {
    var recharge =
      root.querySelector('[data-nerolia-recharge]') ||
      root.querySelector('[id*="shopify-block-recharge"]') ||
      root.querySelector('.shopify-app-block') ||
      root.querySelector('.product-information .product-details');

    if (!recharge) return;

    var pdpType = root.getAttribute('data-nerolia-pdp');
    if (!pdpType && document.body.classList.contains('product-main-product-ritual')) {
      pdpType = 'ritual-kit';
    }
    if (!pdpType && document.body.classList.contains('product-main-product-refill')) {
      pdpType = 'refill';
    }

    function updateSubscriptionUI() {
      var scope = root.querySelector('.product-details') || root;
      var radios = scope.querySelectorAll('input[type="radio"]');
      var isSubscription = false;

      radios.forEach(function (radio) {
        if (!radio.checked) return;
        var label = radio.closest('label') || scope.querySelector('label[for="' + radio.id + '"]');
        var text = (label ? label.textContent : radio.value).toLowerCase();
        if (
          text.indexOf('subscribe') > -1 ||
          text.indexOf('save') > -1 ||
          text.indexOf('ritual') > -1
        ) {
          isSubscription = true;
        }
      });

      var saveWrap = scope.querySelector('.nerolia-pdp__save-note-wrap');
      if (saveWrap) {
        saveWrap.style.display = isSubscription ? 'block' : 'none';
      }

      var buttons = scope.querySelectorAll(
        'button[type="submit"], button[name="add"], [class*="add-to-cart"], .shopify-app-block button'
      );

      buttons.forEach(function (btn) {
        if (pdpType === 'ritual-kit') {
          btn.textContent = isSubscription
            ? 'Add Ritual Kit + Subscription'
            : 'Add Ritual Kit to Cart';
        } else if (pdpType === 'refill') {
          btn.textContent = isSubscription
            ? 'Add Subscription to Basket'
            : 'Add Refill Collection to Cart';
        }
      });
    }

    function addRecommendedBadges() {
      var scope = root.querySelector('.product-details') || root;
      var labels = scope.querySelectorAll('label');

      labels.forEach(function (label) {
        var text = label.textContent.toLowerCase();
        if (
          (text.indexOf('subscribe') > -1 ||
            text.indexOf('save 15') > -1 ||
            text.indexOf('start your ritual') > -1) &&
          !label.querySelector('.nerolia-recommended-badge')
        ) {
          var badge = document.createElement('span');
          badge.className = 'nerolia-recommended-badge';
          badge.textContent = 'Recommended';
          if (getComputedStyle(label).position === 'static') {
            label.style.position = 'relative';
          }
          label.appendChild(badge);
        }
      });
    }

    var scope = root.querySelector('.product-details') || root;
    scope.addEventListener('change', updateSubscriptionUI);

    var observer = new MutationObserver(function () {
      updateSubscriptionUI();
      addRecommendedBadges();
    });

    observer.observe(scope, { childList: true, subtree: true });
    addRecommendedBadges();
    updateSubscriptionUI();
  }

  function initPage(root) {
    initQuantity(root);
    initReferral(root);
    styleRechargeWidget(root);

    if (document.body.classList.contains('product-main-product-ritual')) {
      injectRitualExtras(document.body);
      initReferral(document.body);
      styleRechargeWidget(document.body);
    }

    if (document.body.classList.contains('product-main-product-refill')) {
      injectRefillExtras(document.body);
      initReferral(document.body);
      styleRechargeWidget(document.body);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-nerolia-pdp]').forEach(initPage);

    if (
      document.body.classList.contains('product-main-product-ritual') ||
      document.body.classList.contains('product-main-product-refill')
    ) {
      initPage(document.body);
      setTimeout(function () {
        initPage(document.body);
      }, 1200);
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    var pdp = section.querySelector('[data-nerolia-pdp]');
    if (pdp) initPage(pdp);
    if (section.querySelector('.product-information')) {
      initPage(document.body);
    }
  });
})();
